<template>
  <div class="database">
    <Animate ref="animate" />

    <service-item :links="links" @toLink="toLink"/>
  </div>
</template>

<script>
  import ServiceItem from "@/views/onlineService/childComps/ServiceItem";
  import Animate from "@/components/common/Animate";

  import { insert, queryLink, delLink } from '@/network/link'
  import { queryJno} from "@/network/regLogin";

  import { ElMessage } from 'element-plus'
  import {reactive, ref, getCurrentInstance, onMounted } from "vue";
  import { useRoute, useRouter } from 'vue-router';
  import { useI18n } from 'vue-i18n'//要在js中使用国际化

  export default {
    name: "Database",
    components:{
      ServiceItem,
      Animate,
    },
    setup(){

      // 数据库
      let links = reactive([])
      const router = useRouter()
      // t 引用i18n
      const { t } = useI18n()
      let instance = reactive({})
      instance = getCurrentInstance();

      onMounted(() => {
        let timer = setTimeout(function () {
          instance.proxy.$refs.animate.isShow = false
          clearTimeout(timer)
        }, 100)
      })

      // methods
      // 装填数据库服务
      queryLink(1).then(res1 => {
        if (res1.state === 200)
          res1.data.forEach(item => links.push(item))
      })
      function toLink(link) {
        if (link === 'http://112.126.70.33/bio_data_bacteria/'){
          if (localStorage.getItem('token') !== null){
            location.href = link;
          } else ElMessage.error(t('service.您的登录信息已过期, 请重新登录, 否则无法使用此服务'));
        } else location.href = link;
      }



      return{ links,
        toLink,
      }
    },//setup
  }
</script>

<style scoped lang="less">

  .database{
    margin: 0 10%;
    padding: 50px 0 115px;
    text-align: center;
  }

</style>